<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import { ref } from 'vue';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';

const emit = defineEmits<{
    'update:modelValue': [value: string]
    search: [value: string]
}>();

const props = withDefaults(defineProps<{
    modelValue?: string
    placeholder?: string
}>(), {
    modelValue: '',
    placeholder: 'Search...',
});

const inputDt = ref({
    borderRadius: '10px',
    borderColor: '#E6E9EB',
    hoverBorderColor: '#d0d5da',
    focusBorderColor: '#E6E9EB',
    paddingY: '13.5px',
    shadow: 'none',
});

function clearSearch() {
    emit('update:modelValue', '');
}
</script>

<template>
    <IconField class="tab-search">
        <InputText
            class="tab-search__input"
            :model-value="props.modelValue"
            :placeholder="props.placeholder"
            :dt="inputDt"
            @update:model-value="emit('update:modelValue', $event as string)"
            @keydown.enter="emit('search', props.modelValue)"
        />
        <button
            v-if="props.modelValue"
            type="button"
            class="tab-search__clear"
            aria-label="Clear search"
            @click="clearSearch"
        >
            <i class="pi pi-times" aria-hidden="true" />
        </button>
        <InputIcon v-else class="pi pi-search tab-search__icon" />
    </IconField>
</template>

<style lang="scss" scoped>
.tab-search {
    position: relative;
    width: 323px;
    min-width: 150px;
    flex-shrink: 1;

    :deep(.p-inputtext) {
        width: 100%;
        height: 46px;
        font-family: $font-family-archivo;
        font-size: 16px;
        font-weight: 400;
        color: $black-color;
        padding-right: 42px;

        &::placeholder {
            font-style: italic;
            color: rgba($black-color, 0.4);
        }

        &:focus {
            box-shadow: none;
        }
    }

    :deep(.p-inputicon) {
        color: rgba($black-color, 0.6);
        font-size: 17px;
    }

    &__clear {
        position: absolute;
        top: 50%;
        right: 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        padding: 0;
        border: none;
        border-radius: 6px;
        background: transparent;
        color: rgba($black-color, 0.6);
        cursor: pointer;
        transform: translateY(-50%);
        transition: color 0.15s ease, background-color 0.15s ease;

        &:hover {
            color: $main-orange;
            background: rgba($main-orange, 0.06);
        }

        &:focus-visible {
            outline: 2px solid rgba($main-orange, 0.3);
            outline-offset: 2px;
        }

        i {
            font-size: 13px;
        }
    }
}
</style>
